import { cn } from '@/utils/tailwind-merge';
import { MoveRight } from 'lucide-react';

export default function AnimatedArrow({
    className,
    strokeWidth = 1,
    width = 56,
    height = 48,
}: {
    className?: string;
    strokeWidth?: number;
    width?: number;
    height?: number;
}) {
    return (
        <span
            className={cn(
                'relative flex h-6 items-center justify-center overflow-hidden',
                className,
            )}
            style={{ width }}
        >
            <MoveRight
                strokeWidth={strokeWidth}
                className="absolute transform transition-transform duration-500 group-hover:translate-x-full"
                width={width}
                height={height}
            />
            <MoveRight
                strokeWidth={strokeWidth}
                className="absolute transform transition-transform duration-500 group-hover:translate-x-0 -translate-x-full"
                width={width}
                height={height}
            />
        </span>
    );
}
